import { setCommonAPIError } from "Store/CommonErrorHandler/CommonErrorHandlerAction"
import store from '../redux/store'
import { CONSTANTS } from "client/utils/constants";

export const SetCommonApiHandle = (error: any) => {
    const status = error?.response?.data;
    if (status.ErrorCode == CONSTANTS.ERROR_CODE.STATUS_500) {
        store.dispatch(setCommonAPIError(status));
    }
};

export default {
    SetCommonApiHandle
}